import { getUserObservable } from "services/authUtil";
import _ from "underscore";

export const BROWSER_TAB_ID_KEY = "browser_tab_id";
export const USER_STORAGE_KEY = "user";

// When openning a new tab we hydrate session storage. We pass data between
// tabs via local storage.
export function hydrateSessionStorage() {
  const savedSessionState = localStorage.getItem("sessionStorage");
  if (!savedSessionState) {
    return;
  }
  const data = JSON.parse(String(savedSessionState));

  _.mapObject(data, (val, key) => {
    if (key !== BROWSER_TAB_ID_KEY) {
      sessionStorage.setItem(key, val);
    }
  });
  localStorage.removeItem("sessionStorage");

  const user = JSON.parse(data[USER_STORAGE_KEY]);
  getUserObservable().setValue(user);
}
